// extracted by mini-css-extract-plugin
export var content = "Index-module--content--t5I0A";
export var heading = "Index-module--heading--1dgCr";
export var playerWrapper = "Index-module--playerWrapper--BHnun";
export var flex = "Index-module--flex--MWUOi";
export var timelineWrapper = "Index-module--timelineWrapper--EUfVe";
export var textWrapper = "Index-module--textWrapper--wXkmH";
export var heroText = "Index-module--heroText--hlG+b";
export var cyan = "Index-module--cyan--OO+dr";
export var separator = "Index-module--separator--Vz6NA";